<template>
  <footer>
    <div class="container">
      <div class="demo-block">
        <div class="left-side">
          <h3>Benieuwd wat we voor uw organisatie kunnen betekenen?</h3>
          <p>Neem dan contact met ons op:</p>
          <a
            class="sub-title phone-number"
            href="tel:+31858081120"
          >+31 (0) 85 808 1120</a>
          <p>of vraag een gratis demo aan</p>
          <router-link
            to="/demo"
            class="button primary-button"
            tag="button"
          >
            Gratis demo
          </router-link>
        </div>
        <div class="right-side">
          <img
            src="../assets/img/demo-block.png"
            alt=""
          >
        </div>
      </div>
      <div class="row general-ino-wrapper">
        <div class="col general-info">
          <p class="adresse">
            <a
              href="https://goo.gl/maps/qPgbnKdy52XNnZKy6"
              target="_blank"
            >Amalialaan 126 <br>
              3743 KJ Baarn</a>
          </p>
          <p class="phonenumber">
            <a href="tel:+31858081120">+31 (0) 85 808 1120</a>
          </p>
          <p class="email">
            <a href="mailto:info@roosterplatform.nl">info@roosterplatform.nl</a>
          </p>
        </div>
        <div class="col">
          <p class="title">
            Product
          </p>
          <router-link to="/product">
            Features
          </router-link>
          <router-link to="/clients">
            Klanten
          </router-link>
        </div>
        <div class="col">
          <p class="title">
            Over ons
          </p>
          <router-link to="/about-us">
            Team
          </router-link>
          <!-- <router-link to="/webinar"> Webinar </router-link> -->
          <router-link to="/contact">
            Contact
          </router-link>
        </div>
        <div class="col">
          <p class="title">
            Hulpmiddelen
          </p>
          <router-link to="/blog">
            Blog
          </router-link>
          <a
            href="https://support.roosterplatform.nl/portal/nl/signin#home"
            target="blank"
          >Helpdesk</a>
        </div>
        <div class="col social-media">
          <p class="title">
            Volg ons
          </p>
          <a
            href="https://www.linkedin.com/company/roosterplatform/"
            target="_blank"
          >
            <img
              src="../assets/img/Linkedin.svg"
              alt="Roosterplatform"
            >
          </a>

          <a
            href="https://www.youtube.com/channel/UCJL_x6uHuFfnsPzNo0sdZRw/featured"
            target="_blank"
          >
            <img
              src="../assets/img/YouTube.svg"
              alt="Roosterplatform"
            >
          </a>

          <p class="made-in-baarn">
            Backed by
            <b>Gilde Equity Management</b>
            <img
              src="../assets/img/gilde-equity-management.png"
              alt="Roosterplatform"
            >
          </p>
        </div>
      </div>
    </div>
    <div class="subfooter">
      <div class="container">
        <b-row align-v="center">
          <div class="col logo">
            <img
              src="../assets/img/logo.svg"
              alt="Roosterplatform Logo"
            >
          </div>
          <div class="col text-center copy-right">
            <p>Copyright © 2023 Roosterplatform</p>
          </div>
          <div class="col text-right t-and-c">
            <router-link
              to="/voorwaarden"
              class-active="active"
            >
              Algemene voorwaarden
            </router-link>
            <router-link
              to="/privacy"
              class-active="active"
            >
              privacy statement
            </router-link>
          </div>
        </b-row>
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>

<style scoped lang="scss">
@import "../assets/css/colors.scss";
@import "../assets/css/variables.scss";
.demo-block {
  background: $accent;
  border-radius: $border-radius;
  position: relative;
  top: -200px;
  display: flex;
  border: 10px solid $white;
  max-width: 1000px;
  margin: 0 auto -150px;

  .left-side {
    padding: 40px;
    width: 60%;
    .phone-number {
      color: $primary;
    }
  }
  .right-side {
    position: absolute;
    width: 60%;
    right: 0;
    bottom: 0;
    top: 0;
    text-align: right;

    img {
      height: 100%;
      width: auto;
    }
  }
}

footer {
  background: $grey;
  padding: 50px 0 0;
  z-index: 1;
}

.title {
  font-weight: bold;
}

a {
  display: block;
  color: $text;
  margin: 5px 0;
}

.social-media {
  a {
    display: inline-block;
    margin: 0 5px;
  }
  .made-in-baarn {
    margin: 20px 0 0;
    b {
      display: block;
      margin-bottom: 20px;
    }
    img {
      display: block;
      max-width: 150px;
    }
  }
}

.subfooter {
  background: $grey-dark;
  margin: 50px 0 0;
  display: flex;
  padding: 10px 0;
  a,
  p {
    display: inline-block;
    margin: 0;
    opacity: 0.7;
    font-size: $small;
    + a {
      margin-left: 15px;
    }
  }
  .logo {
    img {
      filter: grayscale(70%);
      opacity: 0.7;
    }
  }
}

@media (max-width: 767px) {
  .demo-block {
    display: block;
    .left-side {
      width: 100%;
      padding: 20px 20px 0;
    }
    .right-side {
      position: relative;
      text-align: right;
      width: 100%;
      img {
        height: auto;
      }
    }
  }
  .general-ino-wrapper {
    display: block;
    text-align: center;
    .col {
      margin-bottom: 40px;
    }
  }
  .subfooter {
    display: block;
    .row {
      display: block;
      > * {
        text-align: center !important;
        margin-bottom: 10px;
      }
    }
  }
}
</style>
